// @mui
import { Paper, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { styled } from '@mui/material/styles';

// @mui icons
import PeopleIcon from '@mui/icons-material/People';
import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';
import { useNavigate } from 'react-router-dom';
import { checkRouteAccess } from '../../utils/common';
import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import Iconify from '../iconify';

const CustomMenuSection = styled('div')(() => ({
  flexDirection: 'column',
  position: 'fixed',
  left: 65,
  minWidth: '72px',
  zIndex: 100,
  color: '#637381',
}));

const MenuPaper = styled(Paper)(({ }) => ({
  width: 225,
  maxHeight: 300,
  overflowY: 'auto',
  overflowX: 'hidden',
  textAlign: 'center',
  ml: '12px',
  mt: '-10px',
  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
  // '&:before': {
  //     content: '""',
  //     display: 'block',
  //     position: 'absolute',
  //     top: 32,
  //     right: 0,
  //     left: -5,
  //     width: 10,
  //     height: 10,
  //     backgroundColor: '#fff',
  //     transform: 'translateY(-50%) rotate(45deg)',
  //     zIndex: 0,
  // },
}));

const VoiceSideBarHoverMenu = ({ custombox }) => {
  const navigate = useNavigate();

  return (
    <CustomMenuSection
      sx={{
        display: custombox ? 'flex' : 'none',
      }}
    >
      <MenuPaper elevation={20}>
        <List
          sx={{
            marginTop: '5px',
            padding: '0px',
          }}
        >
          {checkRouteAccess('/announcementList') && (
            <ListItem
              disablePadding
              sx={{
                margin: '0px',
              }}
            >
              <ListItemButton onClick={() => navigate('/announcementList')}>
                <ListItemIcon
                  sx={{
                    // minWidth: "34px",
                    color: 'grey.600',
                  }}
                >
                  <Iconify icon="mingcute:announcement-line" />
                </ListItemIcon>
                <ListItemText primary="Announcements" sx={{ lineHeight: 1, margin: 0, color: 'grey.600' }} />
              </ListItemButton>
            </ListItem>
          )}

          {checkRouteAccess('/ivrList') && (
            <ListItem
              disablePadding
              sx={{
                margin: '0px',
              }}
            >
              <ListItemButton onClick={() => navigate('/ivrList')}>
                <ListItemIcon
                  sx={{
                    // minWidth: "34px",
                    color: 'grey.600',
                  }}
                >
                  <Iconify icon="tabler:binary-tree-2" />
                </ListItemIcon>
                <ListItemText primary="IVR List" sx={{ lineHeight: 1, margin: 0, color: 'grey.600' }} />
              </ListItemButton>
            </ListItem>
          )}

          {checkRouteAccess('/ttsTemplateList') && (
            <ListItem disablePadding>
              <ListItemButton component="a" onClick={() => navigate('/ttsTemplateList')}>
                <ListItemIcon
                  sx={{
                    // minWidth: "auto",
                    color: 'grey.600',
                  }}
                >
                  <Iconify icon="mdi:tts" />
                </ListItemIcon>
                <ListItemText primary="Tts Templates" sx={{ lineHeight: 1, margin: 0, color: 'grey.600' }} />
              </ListItemButton>
            </ListItem>
          )}

          {checkRouteAccess('/voice_plans') && (
            <ListItem disablePadding>
              <ListItemButton component="a" onClick={() => navigate('/voice_plans')}>
                <ListItemIcon
                  sx={{
                    // minWidth: "auto",
                    color: 'grey.600',
                  }}
                >
                  <Iconify icon="mdi:cash-multiple" />
                </ListItemIcon>
                <ListItemText primary="Voice Plans" sx={{ lineHeight: 1, margin: 0, color: 'grey.600' }} />
              </ListItemButton>
            </ListItem>
          )}
          {checkRouteAccess('/voice-deleted-userList') && (
            <ListItem disablePadding>
              <ListItemButton component="a" onClick={() => navigate('/voice-deleted-userList')}>
                <ListItemIcon
                  sx={{
                    // minWidth: "auto",
                    color: 'grey.600',
                  }}
                >
                  <Iconify icon="mdi:delete-outline" />
                </ListItemIcon>
                <ListItemText primary="Voice Deleted Users" sx={{ lineHeight: 1, margin: 0, color: 'grey.600' }} />
              </ListItemButton>
            </ListItem>
          )}
          {checkRouteAccess('/voice_deleted_campaign_list') && (
            <ListItem disablePadding>
              <ListItemButton component="a" onClick={() => navigate('/voice_deleted_campaign_list')}>
                <ListItemIcon
                  sx={{
                    // minWidth: "auto",
                    color: 'grey.600',
                  }}
                >
                  <Iconify icon="mdi:delete-outline" />
                </ListItemIcon>
                <ListItemText primary="Voice Deleted Campaign" sx={{ lineHeight: 1, margin: 0, color: 'grey.600' }} />
              </ListItemButton>
            </ListItem>
          )}
          {checkRouteAccess('/voice-credit-amount-invoice') && (
            <ListItem disablePadding>
              <ListItemButton component="a" onClick={() => navigate('/voice-credit-amount-invoice')}>
                <ListItemIcon
                  sx={{
                    // minWidth: "auto",
                    color: 'grey.600',
                  }}
                >
                  <Iconify icon="mdi:receipt-text-outline" />
                </ListItemIcon>
                <ListItemText primary="Amount Credit Invoice" sx={{ lineHeight: 1, margin: 0, color: 'grey.600' }} />
              </ListItemButton>
            </ListItem>
          )}
          {checkRouteAccess('/elastic_backup_server') && (
            <ListItem disablePadding>
              <ListItemButton component="a" onClick={() => navigate('/elasticBackupServer')}>
                <ListItemIcon
                  sx={{
                    // minWidth: "auto",
                    color: 'grey.600',
                  }}
                >
                  <Iconify icon="mdi:receipt-text-outline" />
                </ListItemIcon>
                <ListItemText primary="Elastic Backup Server" sx={{ lineHeight: 1, margin: 0, color: 'grey.600' }} />
              </ListItemButton>
            </ListItem>
          )}
          {checkRouteAccess('/NegativeVoiceBalance') && (
            <ListItem disablePadding>
              <ListItemButton component="a" onClick={() => navigate('/NegativeVoiceBalance')}>
                <ListItemIcon
                  sx={{
                    // minWidth: "auto",
                    color: 'grey.600',
                  }}
                >
                  <Iconify icon="fa7-solid:balance-scale-left" />
                </ListItemIcon>
                <ListItemText primary="Negative Voice Balance" sx={{ lineHeight: 1, margin: 0, color: 'grey.600' }} />
              </ListItemButton>
            </ListItem>
          )}
          {checkRouteAccess('/voiceHost') && (
            <ListItem disablePadding>
              <ListItemButton component="a" onClick={() => navigate('/voiceHost')}>
                <ListItemIcon
                  sx={{
                    // minWidth: "auto",
                    color: 'grey.600',
                  }}
                >
                  <Iconify icon="material-symbols:host" />
                </ListItemIcon>
                <ListItemText primary="Host" sx={{ lineHeight: 1, margin: 0, color: 'grey.600' }} />
              </ListItemButton>
            </ListItem>
          )}
          {checkRouteAccess('/voiceGateway') && (
            <ListItem disablePadding>
              <ListItemButton component="a" onClick={() => navigate('/voiceGateway')}>
                <ListItemIcon
                  sx={{
                    // minWidth: "auto",
                    color: 'grey.600',
                  }}
                >
                  <Iconify icon="streamline-ultimate:gateway" />
                </ListItemIcon>
                <ListItemText primary="Voice Gateway" sx={{ lineHeight: 1, margin: 0, color: 'grey.600' }} />
              </ListItemButton>
            </ListItem>
          )}
          {checkRouteAccess('/voiceCli') && (
            <ListItem disablePadding>
              <ListItemButton component="a" onClick={() => navigate('/voiceCli')}>
                <ListItemIcon
                  sx={{
                    // minWidth: "auto",
                    color: 'grey.600',
                  }}
                >
                  <Iconify icon="grommet-icons:cli" />
                </ListItemIcon>
                <ListItemText primary="Voice CLI" sx={{ lineHeight: 1, margin: 0, color: 'grey.600' }} />
              </ListItemButton>
            </ListItem>
          )}
          {checkRouteAccess('/voiceAdminSetting') && (
            <ListItem disablePadding>
              <ListItemButton component="a" onClick={() => navigate('/voiceAdminSetting')}>
                <ListItemIcon
                  sx={{
                    // minWidth: "auto",
                    color: 'grey.600',
                  }}
                >
                  <Iconify icon="icon-park-solid:setting" />
                </ListItemIcon>
                <ListItemText primary="Admin Setting" sx={{ lineHeight: 1, margin: 0, color: 'grey.600' }} />
              </ListItemButton>
            </ListItem>
          )}
          {checkRouteAccess('/voiceAdminSetting') && (
            <ListItem disablePadding>
              <ListItemButton component="a" onClick={() => navigate('/voiceAdminSettingList')}>
                <ListItemIcon
                  sx={{
                    color: 'grey.600',
                  }}
                >
                  <Iconify icon="solar:list-bold" />
                </ListItemIcon>
                <ListItemText primary="Admin Setting List" sx={{ lineHeight: 1, margin: 0, color: 'grey.600' }} />
              </ListItemButton>
            </ListItem>
          )}
        </List>
      </MenuPaper>
    </CustomMenuSection>
  );
};
export default VoiceSideBarHoverMenu;
